export default () => {
  const config = useRuntimeConfig();

  const currentPortalPassPriceIds = computed((): string[] => {
    return [
      config.public.stripePricePortalPassTwentyFive,
      config.public.stripePriceSoftballPortalPassTwentyFive,
    ];
  });

  return {
    currentPortalPassPriceIds,
  };
}; 